<template>
  <div class="filter-item">
    <div class="md-layout">
      <md-datepicker v-model="value" @input="changeFilter">
        <label>дата создания от</label>
      </md-datepicker>
    </div>
    <div class="loading-overlay" v-if="loadStatus">
      <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dateFrom',
  data () {
    return {
      items: [],
      value: null,
      loadStatus: false
    }
  },
  methods: {
    changeFilter () {
      let val = null
      if (!this.value) {
        this.value = null
      } else {
        val = this.value
        val.setHours(0)
        val.setMinutes(0)
        val.setSeconds(0)
      }
      if (val !== null && this.$store.state.filters['createdAtFrom'] !== null && typeof (val) === 'object' && typeof (this.$store.state.filters['createdAtFrom']) === 'object' &&
        val.toString() === this.$store.state.filters['createdAtFrom'].toString()) {
        return
      }
      this.$store.commit('setFilter', {name: 'createdAtFrom', 'value': val})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadStatus = true
    },
    stopLoading () {
      this.loadStatus = false
    }
  },
  created () {
    if (this.$store.state.filters['createdAtFrom'] && this.value === null) {
      this.value = this.$store.state.filters['createdAtFrom']
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/registrationRequests/list/filters/dateFrom.vue